export default __webpack_public_path__ + "static/media/logout.864f30ce.svg";